import { Box, Heading, Icon, Tooltip } from "@chakra-ui/react";
import _ from "lodash";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import FilterForm from "../../../components/FilterForm";
import BranchTicketLookupReport from "../../../components/branches/reports/ticket-info/BranchTicketLookup";
import { Info } from "lucide-react";
import { getReportDescription } from "../../../store/helpers";
import Loader from "../../../components/loader";

const BranchTicketLookup = ({ showFilterForm = true, reportIndex = 1 }) => {
  const { branches, branchId, organizationId, reportRange, workDay } =
    useSelector((state) => state.defaultReducer);
  let branchesClone = _.cloneDeep(branches);
  branchesClone = branchesClone
    .filter(
      (a) =>
        a.reportStatus != null &&
        Number(a.reportStatus) &&
        a.organizationId === organizationId
    )
    .filter((a) => !branchId.length || (branchId.length && a.id === branchId));
  const reportTitle = `Ticket Lookup`;
  useEffect(() => {
    document.title = reportTitle;
  }, []);

  return (
    <Box>
      {showFilterForm ? <FilterForm isTicketLookUp={true} /> : <></>}
      <>
        <Heading fontSize="34px" color="#222" fontWeight="700">
          {reportTitle}
          <Tooltip.Root>
            <Tooltip.Trigger asChild>
              <Icon as={Info} w={5} h={5} ml={2} cursor="pointer" />
            </Tooltip.Trigger>
            <Tooltip.Positioner>
              <Tooltip.Content>
                {getReportDescription(reportRange).TicketLookup}
              </Tooltip.Content>
            </Tooltip.Positioner>
          </Tooltip.Root>
        </Heading>
        {_.isEmpty(workDay) ? (
          <Loader />
        ) : (
          <BranchTicketLookupReport
            reportIndex={reportIndex}
            branches={branchesClone}
          />
        )}
      </>
    </Box>
  );
};

export default BranchTicketLookup;
